export default {
  toasts: {
    load_error: 'Impossibile caricare le tariffe delle commissioni',
    failed_to_save_changes: 'Impossibile salvare le modifiche',
    changes_got_saved: 'Modifiche salvate',
  },
  buttons: {
    edit: 'Modifica',
    cancel: 'Annulla',
    save: 'Salva',
  },
  rates: {
    title: 'Margine di elaborazione',
    description:
      'Percentuale in %, più un importo fisso e un importo minimo facoltativi per addebito. «Qualsiasi metodo di pagamento» si applica quando non esiste una tariffa specifica per il metodo.',
  },
};
